import { useEffect } from 'react';

export default function useScrollAnimation() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const observeElements = () => {
      const animatedElements = document.querySelectorAll(`
        .fade-in-up,
        .fade-in-down,
        .fade-in-left,
        .fade-in-right,
        .scale-in,
        .slide-in-up,
        .slide-in-left,
        .slide-in-right,
        .animate-on-scroll
      `);

      animatedElements.forEach((el) => {
        observer.observe(el);
      });
    };

    observeElements();

    const mutationObserver = new MutationObserver(() => {
      observeElements();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
}
